/* global angular */
angular.module('ua5App')
    .factory('PostFactory', ['$resource', '$rootScope', function($resource, $rootScope) {
        return {
            posts: function() {
                return $resource($rootScope.apiDevUrl + 'posts?page=:page&limit=:limit&homeFeed=:homeFeed', {
                    limit: 25,
                    page: 1,
                    homeFeed: true
                });
            },
            calendarPosts: function() {
                return $resource($rootScope.apiDevUrl + 'posts');
            },
            post: function() {
                return $resource($rootScope.apiDevUrl + 'post/:slug', {
                    slug: '@slug'
                });
            },
            programs: function() {
                return $resource($rootScope.apiDevUrl + 'programs');
            }
        };
    }])
;
